import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "submit"]

  connect() {
    this.inputTargets[0]?.focus()
    this.updateButtonState()
  }

  moveNext(event) {
    const input = event.target
    const value = input.value

    if (value.length === 1) {
      const next = this._nextInput(input)
      next?.focus()
    }
    this.updateButtonState()
  }

  movePrev(event) {
    const input = event.target

    if (event.key === "Backspace" && input.value === "") {
      const prev = this._prevInput(input)
      prev?.focus()
    }
    this.updateButtonState()
  }

  split(e) {
    const digits = e.target.value.replace(/\D/g, '');
    if (digits.length === 6) {
      this.inputTargets.forEach((el, idx) => el.value = digits[idx]);
      this.inputTargets.at(-1).focus();
    }
    this.updateButtonState()
  }

  paste(event) {
    event.preventDefault()
    const paste = event.clipboardData.getData('text').slice(0, this.inputTargets.length)

    paste.split('').forEach((char, index) => {
      if (this.inputTargets[index]) {
        this.inputTargets[index].value = char
      }
    })

    const last = this.inputTargets[paste.length - 1]
    last?.focus()

    this.updateButtonState()
  }
  
  updateButtonState() {
    const allFilled = this.inputTargets.every(input => input.value.length === 1)
    this.submitTarget.disabled = !allFilled
  }  

  _nextInput(current) {
    const index = this.inputTargets.indexOf(current)
    return this.inputTargets[index + 1]
  }

  _prevInput(current) {
    const index = this.inputTargets.indexOf(current)
    return this.inputTargets[index - 1]
  }
}
